module.exports = __webpack_public_path__ + "media/images/categories/2-a79523ed4cb8ba25808981672c7183bc.png";